import React, {  } from 'react';
import styled from 'styled-components/macro';

import { distances, colors } from '../../../styles/constants';
import { InputValidation } from '../../../components/Forms';
import MarketingDropdown from './MarketingDropdown';

interface TimePickerProps {
    name: string;
    value: Date;
    setTime: (time: Date) => void;
    validation?: InputValidation;
    isIndividual?: boolean;
}

const TimePicker = (
    {
        name,
        value,
        setTime,
        validation,
        isIndividual,
    }: TimePickerProps
) => {
    const handleTimeSet = (timeValue: string) => {
        const splittedTimeValue = timeValue.split(':');
        const hourValue = Number(splittedTimeValue[0]);
        const minuteValue = Number(splittedTimeValue[1]);
        const newTime = new Date();
        newTime.setHours(hourValue, minuteValue);
        setTime(newTime);
    };

    const parseTimeValue = () => {
        const hours = value.getHours();
        const minutesPrefix = (value.getMinutes() < 10 ? '0' : '');
        const minutes = `${minutesPrefix}${value.getMinutes()}`;
        return `${hours}:${minutes}`;
    };

    const hours = [...Array(24).keys()];
    const minutes = ['00', '15', '30', '45'];
    const timeOptions = hours.reduce((array, hour) => {
        const hourAsString = hour < 10 ? `0${hour}` : `${hour}`;
        return [...array, ...minutes.map(minute => `${hourAsString}:${minute}`)];
    }, [] as string[]);
    timeOptions.push('23:59');

    const options = timeOptions.map(time => ({
        label: time,
        value: time,
    }));

    return (
        <Wrapper>
            {validation?.message && (
                <Message htmlFor={`${name}_time`} className={validation?.state}>
                    {validation?.message}
                </Message>
            )}
            <MarketingDropdown
                name={`${name}_time`}
                value={{
                    label: parseTimeValue(),
                    value: parseTimeValue(),
                }}
                options={options}
                onChange={option => {
                    handleTimeSet(option.value);
                }}
            />
        </Wrapper>
    );
};

const Wrapper = styled.div`
    position: relative;
`;

const Message = styled.label`
    position: absolute;
    top: 37px;
    left: 0;
    font-size: 11px;
    line-height: ${distances.small};
    white-space: nowrap;

    &.invalid {
        color: ${colors.invalid};
    }

    &.valid {
        color: ${colors.valid};
    }
`;

export default TimePicker;
